ixModuleRouting("impactx.localization",{
    "/countrylist": {
        template: "<ixa-country-list></ixa-country-list>",
        process: "Localization",
        workspace: "admin",
    },
    "/countrydata/:id": {
        template: "<ixa-country-data></ixa-country-data>",
        process: "Localization",
        workspace: "admin",
    },
    "/regionlist": {
        template: "<ixa-region-list></ixa-region-list>",
        process: "Localization",
        workspace: "admin",
    },
    "/regiondata/:id": {
        template: "<ixa-region-data></ixa-region-data>",
        process: "Localization",
        workspace: "admin",
    },
    "/taxlist": {
        template: "<ixa-tax-list></ixa-tax-list>",
        process: "Localization",
        workspace: "admin",
    },
    "/taxdata/:id": {
        template: "<ixa-tax-data></ixa-tax-data>",
        process: "Localization",
        workspace: "admin",
    },
});